export default __webpack_public_path__ + "static/media/etapa1.008f5adf.png";